import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CartService } from 'src/app/services/api/cart.service';
// import { FbpixelService } from 'src/app/services/api/fbpixel.service';
import { FirebaseService } from 'src/app/services/firebase.service';
import { LangService } from 'src/app/services/lang/lang.service';
import { WinService } from 'src/app/services/win.service';
import { environment as env } from 'src/environments/environment';
import { FilesService, UseUploadedFiles } from 'src/app/services/api/files.service';
import { SessionService } from 'src/app/services/session.service';

@Component({
  selector: 'app-tshirt-artwork',
  templateUrl: './tshirt-artwork.component.html',
  styleUrls: ['./tshirt-artwork.component.scss']
})
export class TshirtArtworkComponent implements OnInit {

	
	onClose: any;
	product: any = null;
	selectedProductOptions: any = null;
	instructions: any = '';
	productOptions: any = null;

	quoteId:any = null;
	quoteItemId:any = null;
	selectedQtyPrice:any = null;

	artworkOnly:any = false;
	isAddingItemToCart:boolean = false;

	awupload: string = 'start';

	config: any = null;

	/** upload */
	fileName: any = null;
	file: any = null;

	selectedQty: number = 0;
	doNotMerge: any = null;

	
	/**
	 * Start
	 * uploaded files section
	 */
	useUploadedFiles:UseUploadedFiles = new UseUploadedFiles()
	uploadedFiles:any = this.useUploadedFiles.uploadedFilesInit(this);
	/**
	 * End
	 * uploaded files section
	 */

	constructor(
		public lang: LangService,
		public winService: WinService,
		public cartService: CartService,
		public firebaseService: FirebaseService,	
		// public fbpixel: FbpixelService,
		public router: Router,

		/** this is used by UseUploadedFiles */
		public filesService: FilesService,
		public sessionService: SessionService
	) {
	}

	ngOnInit(): void {
		this.isAddingItemToCart = false;

		this.cartService.get(this.cartService.getStoreUrl('/V1/lns-orderattachment/config')).subscribe(config => {
			this.config = config[0];
		});

		let opt = this.product.options;
		opt.forEach((val) => {
			if (val.title == "do not merge") {
				this.doNotMerge = val;
			}
		});
	}	
	
	/**
	 * close login modal
	 */
	closeModal(added:any = []){
		this.onClose(added);
	}

	/**
	 * switch the modal to upload form
	 */
	uploadArtWorkForm(awu: string = ''){
		if(awu == "layout_catalog"){
			this.uploadedFiles.getUploadedFiles();
		}
		this.awupload = awu;
	}

	

	/**
	 * prepare the file to be uploaded on firestore
	 */
	prepareFile(event){
		let fName = event.target.files[0].name;
		let ext = fName.split('.');
		ext = ext[ext.length - 1];
		ext = ext.toLowerCase();

		if(this.config.accepted_file_type[ext]){
			this.fileName = fName;
			this.file = event;
		} else {
			this.fileName = null;
			this.file = null;
			let types: any = [];
			for (var key in this.config.accepted_file_type) {
			    if (this.config.accepted_file_type.hasOwnProperty(key)) {
			        types.push(key);
			    }
			}
			types = types.join(', ');
			this.cartService.toastService.add('Please upload ' + types + ' only', 'danger');
		}
	}

	startAddToCartV2(){
		if(!this.artworkOnly){
			this.isAddingItemToCart = true;
			this.awupload = 'addingtocart';

			this.cartService.getCartId().then(quote_id => {
				if(quote_id){
					let jsonData = this.getJsonData(quote_id);
					
					let formData = new FormData();
					formData.append('item', JSON.stringify(jsonData));

					if(this.file){
						let file = this.file.target.files[0];
						formData.append('attachment', file);

						let path = env.firebase_path_prefix + 'order/quote_'+ quote_id + '/';
						formData.append('path', path);
						
						formData.append('instructions', this.instructions);
						this.awupload = 'uploaduprogress';
					}
					
					if(this.uploadedFiles.selectedItem.id){
						formData.append('lns_orderattachment_files_id', this.uploadedFiles.selectedItem.id);
					}
					
					this.cartService.addToCartV2(formData, this.firebaseService).then(added => {
						this.cartService.getCart();
						this.cartService.toastService.add(this.lang.getLang('l47'), 'success');
						this.closeModal(added);
						this.cartService.setLoader(false);
					});
				}
			});
		} else {
			let formData = new FormData();
			formData.append('quote_item_id', this.quoteItemId);

			
			if(this.uploadedFiles.selectedItem.id){
				formData.append('lns_orderattachment_files_id', this.uploadedFiles.selectedItem.id);
			}
			else {
				let path = env.firebase_path_prefix + 'order/quote_'+ this.quoteId + '/';
				formData.append('path', path);

				let file = this.file.target.files[0];
				formData.append('attachment', file);

				this.awupload = 'uploaduprogress';
			}
			
			this.cartService.uploadArtWorkOnly(formData, this.firebaseService)
			.then(uploadResult => {
				this.closeModal("success");
			})
			.catch(error => {
				this.closeModal();
				this.cartService.toastService.add(error.message, "danger");
			});
		}
	}

	/**
	 * generate the json request data
	 */
	getJsonData(quote_id: any = null){

		this.productOptions.sizes.forEach(option => {
			if(option._value.length){
				this.selectedQty += parseInt(option._value);
			}
		});
		let d = new Date();
		let customOption: any = [
			{
				option_id: this.selectedProductOptions.color.option_id,
				option_value: this.selectedProductOptions.color.option_type_id,
			},
			{
				option_id: this.doNotMerge.option_id,
				option_value: d.getTime(),
			}
		];

		// let pl = Object.keys(this.selectedProductOptions.print_location);
		// pl.forEach(key => {
		// 	customOption.push({
		// 		option_id: this.selectedProductOptions.print_location[key].option_id,
		// 		option_value: this.selectedProductOptions.print_location[key].option_type_id,
		// 	});
		// });

		let pl = Object.keys(this.selectedProductOptions.print_location);
		let plOptions:any = [];
		let plOptionId:any = 0;
		pl.forEach(key => {
			plOptionId = this.selectedProductOptions.print_location[key].option_id
			plOptions.push(this.selectedProductOptions.print_location[key].option_type_id);
		});

		customOption.push({
			option_id: plOptionId,
			option_values: plOptions
		});

		let ps = Object.keys(this.productOptions.print_size);
		ps.forEach(key => {
			if( 
				this.productOptions.print_size[key].width_value && this.productOptions.print_size[key].height_value 
			){
				let value = this.productOptions.print_size[key].width_value;
				value += ' cm X ';
				value += this.productOptions.print_size[key].height_value;
				value += ' cm';

				customOption.push({
					option_id: this.productOptions.print_size[key].option_id,
					option_value: value 
				});
			}
		});

		this.productOptions.sizes.forEach(sizeOption => {
			customOption.push({
				option_id: sizeOption.option_id,
				option_value: sizeOption._value,
			});
		});

		let jsonData = {
			"cartItem": {
				"sku": this.product.sku,
				"qty": this.selectedQty,
				"quote_id": quote_id,
				"product_option": {
					"extension_attributes": {
						"custom_options": customOption
					}
				},
				"extension_attributes": {}
			}
		};
		return jsonData;
	}

	// fbPixel(){
	// 	this.fbpixel.fbq('track', 'AddToCart', {
	// 		content_name: this.product.sku,
	// 		content_category: 'Default',
	// 		content_ids: [this.product.id],
	// 		content_type: 'product',
	// 		value: this.selectedQtyPrice,
	// 		currency: 'PHP'
	// 	});
	// }

}
